/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface OneDWaterLevelFile
 */
export interface OneDWaterLevelFile {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  initialWaterlevel: string;
  /**
   *
   */
  readonly initialWaterlevelId?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the OneDWaterLevelFile interface.
 */
export function instanceOfOneDWaterLevelFile(value: object): value is OneDWaterLevelFile {
  if (
    (!("initialWaterlevel" in (value as Record<string, any>)) &&
      !("initial_waterlevel" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["initialWaterlevel"] === undefined &&
      (value as Record<string, any>)["initial_waterlevel"] === undefined)
  )
    return false;
  return true;
}

export function OneDWaterLevelFileFromJSON(json: any): OneDWaterLevelFile {
  return OneDWaterLevelFileFromJSONTyped(json, false);
}

export function OneDWaterLevelFileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OneDWaterLevelFile {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    initialWaterlevel: json["initial_waterlevel"],
    initialWaterlevelId:
      json["initial_waterlevel_id"] == null ? undefined : json["initial_waterlevel_id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function OneDWaterLevelFileToJSON(json: any): OneDWaterLevelFile {
  return OneDWaterLevelFileToJSONTyped(json, false);
}

export function OneDWaterLevelFileToJSONTyped(
  value?: Omit<
    OneDWaterLevelFile,
    "url" | "simulation" | "initialWaterlevelId" | "uid" | "id"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    initial_waterlevel: value["initialWaterlevel"],
  };
}
